:host {
  background-color: var(--white-layout-301-level-0-elevation);
  max-width: 100%;
}

.wrapper {
  flex-direction: column;
  height: 100%;
}

.companies-header {
  display: flex;
  flex-direction: column;
  padding: calc(var(--spacer) * 2) calc(var(--spacer) * 2) calc(var(--spacer) * 3) calc(var(--spacer) * 2);
  height: 64px;

  &--top {
    display: flex;
    justify-content: space-between;
  }
}

.title {
  color: var(--body-text-arrows-400);
}

.loading-error {
  display: none;
  height: auto;
  width: 500px;
  margin: auto;

  &--message {
    max-width: 310px;
    line-height: 1.25;
  }
}

.companies-content {
  flex-grow: 2;
  height: 100%;
}

.page__header {
  padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(2.5 * var(--spacer));
  line-height: 33px;
}
